import { components } from "@certn/api/generated-schemas/client-portal";
import { Stack, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { Claims } from "./Claims";

type Props = components["schemas"]["CheckDocumentationCaseCommon"] &
  components["schemas"]["CheckDocumentationCaseEmployment"] &
  components["schemas"]["CheckDocumentationCaseTenancy"] & {
    testID: string;
  };

export const CaseDocs = ({
  name,
  description,
  input_claims,
  testID,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Stack data-testid={testID} gap="space-1">
      <Text as="h3" style="global/heading-medium">
        {name}
      </Text>
      <Text>{description}</Text>
      <Claims
        testID="common-input-claims"
        claims={input_claims as object}
        title={t("Input claims JSON schema")}
      />
    </Stack>
  );
};
